<div class="blog-block-link">
  <a
    class="blog-block-link__anchor"
    [href]="block.url"
    [attr.target]="target"
    [attr.rel]="rel"
  >
    <span>{{ block.label }}</span>
    <icon name="navigate_next" class="blog-block-link__icon"></icon>
  </a>
</div>
